import React, { useEffect, useState } from 'react'
import { useGeneralParams } from '../../../../hooks/useDataPaginate'
import { MinimalActionButton } from '../../../../components/form/minimalActionButton'
import { setReloadMainTable } from '../../../../store/slices/auth/authSlice'
import { useSelector } from 'react-redux'
import { TabBoard } from '../../../../components/tab/TabBoard'
import Bars from './VentaPorVendedorProductoBarsCharts'
import { DefaultParamsForRecall } from '../../../../utils/defaulStates'
import Tooltip from '../../../../components/tooltips/Tooltip'
import { exportEstadoToPdf, exportEstadoToExcel } from '../../../../utils/exportCuaderno'
import { GenerateDocFile } from '../../../../utils/generateDoc'
import { InputSelect } from '../../../../components/form/FormMultiParams'

const formatNum = (val) =>
    val != null
        ? Number(val).toLocaleString('es-BO', { minimumFractionDigits: 2 })
        : '0,00'

const NumCell = ({ value, color }) => (
    <div className='flex justify-end'>
        <div className={`${color ?? 'dark:bg-gray-800 bg-green-100'} dark:text-gray-300 text-gray-700 px-1 font-semibold rounded-sm`}>
            {formatNum(value)}
        </div>
    </div>
)

const ExpandableRow = ({ item }) => {
    const [expanded, setExpanded] = useState(false)

    const desglose = item.desglose
    const ingresos = desglose?.ingresos
    const egresos = desglose?.egresos
    const hasDesglose = !!desglose

    const [montoTotal, montoIngreso, montoEgreso] = item.cantidades ?? [0, 0, 0]

    return (
        <>
            <tr className='group bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800'>
                <td className='border border-gray-300 dark:border-gray-800 transition-all duration-1000 ease-in-out'>
                    <div className='px-2 py-1 text-gray-900 dark:text-white'>
                        <div className='font-semibold'>{item.nombre}</div>

                        {item.encargado_nombre && (
                            <div className='font-semibold text-xs text-gray-400 dark:text-gray-500'>
                                {item.encargado_nombre}
                                {item.encargado_detalles ? ` · ${item.encargado_detalles}` : ''}
                            </div>
                        )}

                        {item.producto_nombre && (
                            <div className='font-semibold text-xs text-gray-400 dark:text-gray-500'>
                                {item.producto_nombre}
                            </div>
                        )}
                    </div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1'>
                        <NumCell value={montoTotal} />
                    </div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1'>
                        <NumCell value={montoIngreso} color='dark:bg-gray-800 bg-blue-100' />
                    </div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1'>
                        <NumCell value={montoEgreso} color='dark:bg-gray-800 bg-red-100' />
                    </div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1 flex justify-center' onClick={e => e.stopPropagation()}>
                        {hasDesglose && (
                            <Tooltip text='Ver desglose'>
                                <button
                                    className={`flex h-8 w-8 justify-center items-center rounded-md cursor-pointer
                                        ${expanded
                                            ? 'text-blue-500 dark:text-blue-400'
                                            : 'text-blue-400 dark:text-blue-500 dark:hover:bg-gray-900 hover:bg-stone-200'}`}
                                    onClick={() => setExpanded(p => !p)}
                                >
                                    <i className={`fa-solid fa-chevron-${expanded ? 'up' : 'down'} text-lg`} />
                                </button>
                            </Tooltip>
                        )}
                    </div>
                </td>
            </tr>

            {expanded && hasDesglose && (
                <tr className='bg-gray-50 dark:bg-gray-800/60'>
                    <td
                        colSpan={5}
                        className='border border-gray-300 dark:border-gray-800 px-4 py-3'
                    >
                        <div className='flex flex-col gap-4'>

                            {ingresos && (
                                <div className='w-full'>
                                    <p className='text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5 flex items-center gap-1.5'>
                                        <i className='fa-solid fa-arrow-trend-up text-green-500' />
                                        Ingresos
                                    </p>

                                    <table className='w-full text-sm border border-gray-300 dark:border-gray-700'>
                                        <thead className='text-sm bg-gray-600 dark:bg-gray-900 text-gray-200 dark:text-gray-400'>
                                            <tr>
                                                <th className='px-3 py-2 border border-gray-600 dark:border-gray-800 text-left'>
                                                    Concepto
                                                </th>
                                                <th className='px-3 py-2 border border-gray-600 dark:border-gray-800 text-right'>
                                                    Monto Bs.
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {[
                                                ['Ventas carros', ingresos.ventas_carros, null],
                                                ['Ventas tiendas', ingresos.ventas_tiendas, null],
                                                ['Otros ingresos', ingresos.otros_ingresos, null],
                                            ].map(([label, value, cls]) => (
                                                <tr key={label} className='bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800'>
                                                    <td className='px-3 py-1.5 border border-gray-300 dark:border-gray-800 text-gray-500 dark:text-gray-400'>
                                                        {label}
                                                    </td>
                                                    <td className={`px-3 py-1.5 border border-gray-300 dark:border-gray-800 text-right font-mono text-gray-700 dark:text-gray-300 ${cls ?? ''}`}>
                                                        {formatNum(value)}
                                                    </td>
                                                </tr>
                                            ))}

                                            <tr className='bg-gray-600 dark:bg-gray-800'>
                                                <td className='px-3 py-1.5 border border-gray-600 dark:border-gray-700 text-white font-bold'>
                                                    Total ingresos
                                                </td>
                                                <td className='px-3 py-1.5 border border-gray-600 dark:border-gray-700 text-right font-mono text-white font-bold'>
                                                    {formatNum(ingresos.total_ingresos)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {egresos && (
                                <div className='w-full'>
                                    <p className='text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5 flex items-center gap-1.5'>
                                        <i className='fa-solid fa-arrow-trend-down text-red-500' />
                                        Egresos
                                    </p>

                                    <table className='w-full text-sm border border-gray-300 dark:border-gray-700'>
                                        <thead className='text-sm bg-gray-600 dark:bg-gray-900 text-gray-200 dark:text-gray-400'>
                                            <tr>
                                                <th className='px-3 py-2 border border-gray-600 dark:border-gray-800 text-left font-semibold'>
                                                    Tipo
                                                </th>
                                                <th className='px-3 py-2 border border-gray-600 dark:border-gray-800 text-right font-semibold'>
                                                    Monto Bs.
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {egresos.conceptos?.length > 0 ? (
                                                egresos.conceptos.map((c, idx) => (
                                                    <tr key={idx} className='bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800'>
                                                        <td className='px-3 py-1.5 border border-gray-300 dark:border-gray-800 text-gray-500 dark:text-gray-400'>
                                                            {c.tipo}
                                                        </td>
                                                        <td className='px-3 py-1.5 border border-gray-300 dark:border-gray-800 text-right font-mono text-red-500 dark:text-red-400'>
                                                            {formatNum(c.totalAbs)}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr className='bg-white dark:bg-gray-900'>
                                                    <td
                                                        colSpan={2}
                                                        className='px-3 py-2 border border-gray-300 dark:border-gray-800 text-center text-gray-400 italic'
                                                    >
                                                        Sin egresos
                                                    </td>
                                                </tr>
                                            )}

                                            <tr className='bg-gray-600 dark:bg-gray-800'>
                                                <td className='px-3 py-1.5 border border-gray-600 dark:border-gray-700 text-white font-bold'>
                                                    Total egresos
                                                </td>
                                                <td className='px-3 py-1.5 border border-gray-600 dark:border-gray-700 text-right font-mono text-white font-bold'>
                                                    {formatNum(egresos.total_egresos_abs)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {desglose?.neto != null && (
                                <div className='w-full'>
                                    <div className='flex justify-end'>
                                        <div className='flex items-center gap-3 bg-gray-600 dark:bg-gray-800 text-white rounded px-5 py-2.5'>
                                            <span className='text-sm font-semibold uppercase tracking-wide text-gray-300'>
                                                Monto Total Neto
                                            </span>
                                            <span className='font-mono font-bold text-base'>
                                                {formatNum(desglose.neto)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </td>
                </tr>
            )}
        </>
    )
}

export const EstadoDeCuentas = ({ urlApi, title, subtitle }) => {
    const {
        dispatch,
        data, setData,
        paginate, setPaginate,
        selecteds, setSelecteds,
        selectAllChecked, setSelectAllChecked,
        isChecked, setIsChecked,
        stateData, setStateData,
        requestAuthPaginate,
        Paginator,
        TableSection,
        ActionSection,
        Section,
    } = useGeneralParams()

    const reloadSubTable = useSelector(state => state.login.reloadSubTable)
    const [selectedCierreNombre, setSelectedCierreNombre] = useState('')

    const getDataPaginate = async (customPaginate = paginate) => {
        await requestAuthPaginate({
            method: 'get',
            url: urlApi,
            data: null,
            queries: customPaginate,
            setData: setData,
            setStateData: setStateData,
            setQueries: setPaginate,
            dispatch: dispatch,
            aditionalParams: {}
        })
    }

    useEffect(() => {
        getDataPaginate()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), reloadSubTable])

    useEffect(() => {
        setSelectAllChecked(false)
        setIsChecked(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate)])

    useEffect(() => {
        if (data?.cierreSeleccionado !== undefined && data?.cierreSeleccionado !== null) {
            setSelectedCierreNombre(String(data.cierreSeleccionado))
        }
    }, [data?.cierreSeleccionado])

    const recall = async () => {
        const nextPaginate = {
            ...paginate,
            currentPage: 1,
        }

        setPaginate(nextPaginate)
        await getDataPaginate(nextPaginate)

        setSelecteds([])
        setSelectAllChecked(false)
        setIsChecked(false)
        dispatch(setReloadMainTable())
    }

    const handleChangeCierre = async (selectedOption) => {
        const nextPaginate = {
            ...paginate,
            currentPage: 1,
            cierre_nombre: selectedOption?.value ?? '',
        }

        setSelectedCierreNombre(String(selectedOption?.value ?? ''))
        setPaginate(nextPaginate)
        await getDataPaginate(nextPaginate)

        setSelecteds([])
        setSelectAllChecked(false)
        setIsChecked(false)
    }

    const aditionalCols = data?.aditionalCols ?? []

    const cierreOptions = (data?.cierresDisponibles ?? []).map(item => ({
        value: item.nombre,
        label: item.label ?? item.nombre,
    }))

    const totales = (() => {
        const rows = data?.data ?? []
        if (!rows.length) return []
        const len = rows[0].cantidades?.length ?? 0

        return Array.from({ length: len }, (_, i) =>
            rows.reduce((acc, row) => acc + (row.cantidades?.[i] ?? 0), 0)
        )
    })()

    return (
        <TabBoard title={title} subtitle={subtitle}>
            <Section>
                <ActionSection>
                    <div className='flex gap-2 flex-wrap items-center'>
                        <div className='flex items-center gap-2 flex-wrap'>
                            <span className='text-sm font-semibold text-gray-600 dark:text-gray-300'>
                                Cierre:
                            </span>

                            <div className='min-w-[260px] max-w-[320px]'>
                                <InputSelect
                                    options={cierreOptions}
                                    value={selectedCierreNombre}
                                    onChange={handleChangeCierre}
                                    placeholder='Buscar cierre...'
                                    usePortal={true}
                                    className='input-select'
                                />
                            </div>
                        </div>

                        <MinimalActionButton icon='repeat' label='' action={recall} />
                    </div>
                </ActionSection>

                <TableSection stateData={stateData} paginator={Paginator} data={data}>
                    <div className='overflow-auto'>
                        <div className='flex justify-start gap-2 py-1 px-1'>
                            <GenerateDocFile
                                icon='fa-file-excel'
                                color='green'
                                label='Excel'
                                onClick={() => exportEstadoToExcel(data?.data ?? [], data?.aditionalCols ?? [])}
                            />

                            <GenerateDocFile
                                icon='fa-file-pdf'
                                color='red'
                                label='PDF'
                                onClick={() => exportEstadoToPdf(data?.data ?? [], data?.aditionalCols ?? [])}
                            />
                        </div>

                        <table className='w-full text-sm text-left text-gray-500 dark:text-gray-400'>
                            <thead className='text-xs text-gray-100 capitalcase bg-gray-600 dark:bg-gray-900 dark:text-gray-300'>
                                <tr>
                                    <th className='px-2 py-3 border border-gray-600 dark:border-gray-800 bg-gray-600 dark:bg-gray-900 text-gray-200 dark:text-gray-400'>
                                        Cuenta
                                    </th>

                                    {aditionalCols.map(col => (
                                        <th
                                            key={col}
                                            className='px-2 py-3 border border-gray-600 dark:border-gray-800 bg-gray-600 dark:bg-gray-900 text-gray-200 dark:text-gray-400 text-right'
                                        >
                                            {col}
                                        </th>
                                    ))}

                                    <th className='px-2 py-3 border border-gray-600 dark:border-gray-800 bg-gray-600 dark:bg-gray-900 text-gray-200 dark:text-gray-400 text-center'>
                                        Desglose
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {Array.isArray(data?.data) && data.data.map(item => (
                                    <ExpandableRow
                                        key={item.id}
                                        item={item}
                                    />
                                ))}

                                {Array.isArray(data?.data) && data.data.length > 0 && (
                                    <tr>
                                        <td className='px-2.5 bg-gray-300 dark:bg-gray-900'>
                                            <div className='p-1' />
                                        </td>

                                        {totales.map((val, i) => (
                                            <td
                                                key={i}
                                                className='px-2.5 text-white text-right font-semibold bg-gray-600 dark:bg-gray-800'
                                            >
                                                <div className='p-1'>{formatNum(val)}</div>
                                            </td>
                                        ))}

                                        <td className='px-2.5 bg-gray-300 dark:bg-gray-900'>
                                            <div className='p-1' />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </TableSection>
            </Section>

            <Bars
                data={data?.data ?? []}
                aditionalCols={data?.aditionalCols ?? []}
                hoverTitle='Total'
            />
        </TabBoard>
    )
}